
import { Mapper } from "../../../../base/utils/mapper";
import { DiagnosticMedicalRehabilityPhysiotherapyResponseModel } from "../../../../domain/models/consult/diagnostic-medical-rehability-physiotherapy-response.model";
import { DiagnosticMedicalRehabilityPhysiotherapyResponseEntity } from "../entities/diagnostic-medical-rehability-physiotherapy-response.entity";
    export class DiagnosticMedicalRehabilityPhysiotherapyImplementationRepositoryMapper extends Mapper<DiagnosticMedicalRehabilityPhysiotherapyResponseEntity, DiagnosticMedicalRehabilityPhysiotherapyResponseModel>{
    mapFrom(param:  DiagnosticMedicalRehabilityPhysiotherapyResponseEntity):  DiagnosticMedicalRehabilityPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  DiagnosticMedicalRehabilityPhysiotherapyResponseModel):  DiagnosticMedicalRehabilityPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }